export const environment = {
  production: true,
  buildId: '{BUILD_ID}',
  polygonConfig: {
    network: 'https://polygon-amoy.infura.io/v3/47a6cfe491ac4ff3bf8284eeae3ec55b'
  },
  ipfsConfig: {
    url: 'https://rpc.filebase.io',
    token: 'QTEyNUIwOENGNDhEODU1NkJDRUU6NTNlTjA3ZEpTZ0hqSzB6dHR3NEM1YVlTbmJTa3owTzNZbHlMNHBaUzpwcm9ncmFtbWFibGUtbW9uZXk=',
  },
  verifierConfig: {
    host: 'https://ovo.pm.yanacocha.fit.fraunhofer.de',
    username: 'pmovodemo',
    password: 'eSTernIalHeL',
  },
  authExpire: 240000,
  serverQueryRate: 1000
};
